/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
    // Add custom code below this line

    /* Group special variations in a dropdown (only for attribute Size) */
    if (
        document.querySelectorAll(".radio__button-variant-option-special").length >
        0
    ) {
        // build accordion
        const radio_accordion_wrapper = document.createElement(
            "collapsible-elements"
        );
        radio_accordion_wrapper.setAttribute("single", true);
        let radio_accordion_child_1 = document.createElement("div");
        radio_accordion_child_1.classList.add("product-accordion");
        let radio_accordion_child_1_1 = document.createElement("details");
        radio_accordion_child_1_1.classList.add("accordion");
        radio_accordion_child_1_1.setAttribute("data-collapsible", "");
        radio_accordion_child_1_1.id = "other-sizes";
        let radio_accordion_child_1_1_1 = document.createElement("summary");
        radio_accordion_child_1_1_1.classList.add("accordion__title");
        radio_accordion_child_1_1_1.setAttribute("data-collapsible-trigger", "");
        let radio_accordion_child_1_1_1_1 =
            '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 24 24"><path d="M6 12h6m6 0h-6m0 0V6m0 6v6" stroke="#000" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
        let radio_accordion_child_1_1_1_2 =
            '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" viewBox="0 0 24 24"><path d="M6 12h12" stroke="#000" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
        radio_accordion_child_1_1_1.innerHTML =
            document.getElementById("other_sizes_label").textContent +
            radio_accordion_child_1_1_1_1 +
            radio_accordion_child_1_1_1_2;
        let radio_accordion_child_1_1_2 = document.createElement("div");
        radio_accordion_child_1_1_2.classList.add("accordion__body");
        radio_accordion_child_1_1_2.classList.add("rte");
        radio_accordion_child_1_1_2.setAttribute("data-collapsible-body", "");
        const params = new URLSearchParams(window.location.search);
        if (params.get("accordion") === "other-sizes") {
            radio_accordion_child_1_1.setAttribute("open", "true");
            radio_accordion_child_1_1_2.style.height = "auto";
        }
        let radio_accordion_child_1_1_2_1 = document.createElement("div");
        radio_accordion_child_1_1_2_1.classList.add("accordion__subtitle");
        radio_accordion_child_1_1_2_1.classList.add("body-size-2");
        let radio_accordion_child_1_1_2_2 = document.createElement("div");
        radio_accordion_child_1_1_2_2.classList.add("accordion__content");
        radio_accordion_child_1_1_2_2.setAttribute("data-collapsible-content", "");
        let radio_accordion_child_1_1_2_1_1 =
            document.createElement("toggle-ellipsis");
        radio_accordion_child_1_1_2_1_1.setAttribute("data-height", "1200");
        radio_accordion_child_1_1_2_1_1.classList.add("is-open");
        let radio_accordion_child_1_1_2_1_1_1 = document.createElement("div");
        radio_accordion_child_1_1_2_1_1_1.classList.add("toggle-ellipsis__content");
        radio_accordion_child_1_1_2_1_1_1.setAttribute("data-content", "");
        let radio_accordion_child_1_1_2_1_1_2 = document.createElement("div");
        radio_accordion_child_1_1_2_1_1_2.classList.add("toggle-ellipsis__actions");
        radio_accordion_child_1_1_2_1_1_2.setAttribute("data-actions", "");
        let radio_accordion_child_1_1_2_1_1_2_1 = document.createElement("button");
        radio_accordion_child_1_1_2_1_1_2_1.setAttribute("type", "button");
        radio_accordion_child_1_1_2_1_1_2_1.classList.add("caps--link");
        radio_accordion_child_1_1_2_1_1_2_1.setAttribute("data-button", "");
        radio_accordion_child_1_1_2_1_1_2_1.innerHTML =
            "<span>" +
            document.getElementById("show_more_label").textContent +
            "</span>";

        radio_accordion_child_1_1_2_1_1_2.appendChild(
            radio_accordion_child_1_1_2_1_1_2_1
        );
        radio_accordion_child_1_1_2_1_1.appendChild(
            radio_accordion_child_1_1_2_1_1_1
        );
        radio_accordion_child_1_1_2_1_1.appendChild(
            radio_accordion_child_1_1_2_1_1_2
        );
        radio_accordion_child_1_1_2_2.appendChild(radio_accordion_child_1_1_2_1_1);
        radio_accordion_child_1_1_2.appendChild(radio_accordion_child_1_1_2_1);
        radio_accordion_child_1_1_2.appendChild(radio_accordion_child_1_1_2_2);
        radio_accordion_child_1_1.appendChild(radio_accordion_child_1_1_1);
        radio_accordion_child_1_1.appendChild(radio_accordion_child_1_1_2);
        radio_accordion_child_1.appendChild(radio_accordion_child_1_1);
        radio_accordion_wrapper.appendChild(radio_accordion_child_1);

        document
            .querySelectorAll(".radio__button-variant-option-special")
            .forEach((variant_option_special) =>
                radio_accordion_child_1_1_2_1_1_1.appendChild(variant_option_special)
            );
        document.querySelector(
            ".radio__fieldset--variant-option-size .radio__buttons"
        ).innerHTML =
            document.querySelector(
                ".radio__fieldset--variant-option-size .radio__buttons"
            ).innerHTML + radio_accordion_wrapper.outerHTML;

        // open accordion if the special variant already selected
        setTimeout(function () {
            if (
                document.querySelectorAll(
                    ".radio__button-variant-option-special input[checked]"
                ).length > 0
            ) {
                document
                    .querySelector(".radio__fieldset--variant-option-size summary")
                    .click();
                document
                    .querySelector(".radio__fieldset--variant-option-size [data-button]")
                    .click();
            }
        });
    }

    // add listener to variants to update shipping label
    function hideShippingLabelTruck(add_hidden = false) {
        // shipping label identified by truck-icon
        let shipping_label = document.querySelector('.product__block.block__icon__container:has(.icon-truck)')
        if(null === shipping_label) shipping_label = document.querySelector('.product__block.block__icon__container:has(.icon-box)')

        for (let i = 0; i < shipping_label.childNodes.length; i++) {
            shipping_label.childNodes[i].classList.remove('aos-animate')
            //if(add_hidden) shipping_label.childNodes[i].classList.add('invisible')
        }

        // hide custom accordion subtitle
        let accordion_subtitle = document.querySelector('.accordion__subtitle');
        if(!add_hidden && null != accordion_subtitle) {
            accordion_subtitle.classList.remove('visible')
            setTimeout(function () {
                accordion_subtitle.textContent = "";
            }, 300)
        }
    }

    function showShippingLabelTruck(new_shipping_label, new_accordion_subtitle = "") {
        // shipping label identified by truck-icon
        let shipping_label = document.querySelector('.product__block.block__icon__container:has(.icon-truck)')
        if(null === shipping_label) shipping_label = document.querySelector('.product__block.block__icon__container:has(.icon-box)')
        for (let i = 0; i < shipping_label.childNodes.length; i++)
        {
            let node = shipping_label.childNodes[i]

            setTimeout(function () {
                if(node.classList.contains('block__icon__text') && new_shipping_label !== null){
                    node.innerHTML = '<p>'+new_shipping_label+'</p>'
                }
                if(node.classList.contains('invisible'))
                {
                    node.classList.remove('invisible')
                }
                node.classList.add('aos-animate')
            },500)
        }

        // hide/show custom accordion subtitle
        let accordion_subtitle = document.querySelector('.accordion__subtitle');
        if(null !== accordion_subtitle) {
            if (new_accordion_subtitle === "") {
                accordion_subtitle.classList.remove('visible')
                setTimeout(function () {
                    accordion_subtitle.textContent = new_accordion_subtitle
                }, 300)
            } else {
                accordion_subtitle.textContent = new_accordion_subtitle
                accordion_subtitle.classList.add('visible')
            }
        }
    }

    let variant_options_special = document.getElementsByClassName('radio__button-variant-option-special')
    if(variant_options_special.length > 0) {
        for (let i = 0; i < variant_options_special.length; i++) {
            variant_options_special[i].addEventListener("click", event => {
                let shipping_label_1 = variant_options_special[i].getAttribute('data-shipping-label')
                let new_accordion_subtitle_1 = variant_options_special[i].getAttribute('data-accordion-subtitle')
                hideShippingLabelTruck(true)
                showShippingLabelTruck(shipping_label_1, new_accordion_subtitle_1)
            });
        }

        // update shipping label if special variant already selected
        let variant_options_special_checked = document.querySelectorAll(".radio__button-variant-option-special input[checked]")
        if (variant_options_special_checked.length > 0) {
            let shipping_label_2 = variant_options_special_checked[0].parentElement.getAttribute('data-shipping-label')
            let new_accordion_subtitle_2 = variant_options_special_checked[0].parentElement.getAttribute('data-accordion-subtitle')
            showShippingLabelTruck(shipping_label_2, new_accordion_subtitle_2)
        }
    }

    // display the shipping label on normal variant
    let variant_options_normal = document.querySelectorAll('.radio__button[data-shipping-label]:not(.radio__button-variant-option-special)')
    if(variant_options_normal.length > 0){
        for (let i = 0; i < variant_options_normal.length; i++) {
            variant_options_normal[i].addEventListener("click",event => {
                let shipping_label_3 = variant_options_normal[i].getAttribute('data-shipping-label')
                hideShippingLabelTruck()
                showShippingLabelTruck(shipping_label_3)
            });
        }
    }

    /* Save customization_text field for products */
    const required_fields = []

    // handle custom text input
    const customization_text_input =
        document.getElementById("customization_text");
    if (null !== customization_text_input) {
        if(customization_text_input.getAttribute('required') !== null) required_fields.push('customization_text_hidden')

        // add hidden input to the product-form
        let hidden_input = document.createElement("input");
        hidden_input.setAttribute("type", "hidden");
        hidden_input.setAttribute(
        "name",
        'properties[' + customization_text_input.getAttribute("data-name") + ']'
        );
        hidden_input.setAttribute("value", "");
        hidden_input.setAttribute("id", "customization_text_hidden");
        document.querySelector("form.product-form").appendChild(hidden_input);

        customization_text_input.addEventListener("input", function () {
        this.classList.remove('input-error');

        let value = this.value.toLowerCase();
        const mayusRadio = document.getElementById("initial_mayus");
        if (mayusRadio && mayusRadio.checked && value.length > 0) {
            value = value.charAt(0).toUpperCase() + value.slice(1);
        }

        this.value = value;
        document.getElementById("customization_text_hidden").setAttribute("value", value);

        if (value === '' && customization_text_input.getAttribute('required') !== null) {
            this.classList.add('input-error');
        }
        });

        const radios = document.querySelectorAll('input[name="primera_letra_visible"]');

        if (radios.length > 0) {
        const form = document.querySelector("form.product-form");

        if (form) {
            const hiddenInput = document.createElement("input");
            hiddenInput.type = "hidden";
            hiddenInput.name = 'properties[' + radios[0].getAttribute("data-name") + ']';
            hiddenInput.value = document.querySelector('input[name="primera_letra_visible"]:checked')?.value || '';
            hiddenInput.id = "inicial_hidden";

            form.appendChild(hiddenInput);

            radios.forEach((radio) => {
            radio.addEventListener("change", function () {
                hiddenInput.value = this.value;
                customization_text_input.dispatchEvent(new Event('input'));
            });
            });
        }
        }

        // handle custom text length by numbers
        let letter_selector = document.querySelector('[data-product-variants] .radio__legend__option-name');
        if(null !== letter_selector && letter_selector.textContent === document.getElementById('letter_variant_text_identifier').value)
        {
            let radio_buttons = letter_selector.parentElement.parentElement.nextElementSibling;
            if(radio_buttons.classList.contains('radio__buttons'))
            {
                radio_buttons.childNodes.forEach((element) => {
                    if(undefined !== element.classList && element.classList.contains('radio__button'))
                    {
                        // check already selected variants
                        for(let i = 0; i < element.children.length; i++){
                            if (element.children[i].tagName === "INPUT" && element.children[i].checked) {
                                customization_text_input.setAttribute('maxlength', element.children[i].value)
                            }
                        }
                        
                        element.addEventListener("click", (event) => {
                            customization_text_input.value = ""
                            document.getElementById('customization_text_hidden').value = ""

                            for(let i = 0; i < element.children.length; i++){
                                if (element.children[i].tagName === "INPUT") {
                                    customization_text_input.setAttribute('maxlength', element.children[i].value)
                                }
                            }
                        })
                    }
                })
            }
        }
    }

    /* Save Chain color selects fields for products */
    // handle chain gold color select
    const chain_color_select_chain =
        document.getElementById("chain-color-select-chain");
    if (null !== chain_color_select_chain) {
        required_fields.push('chain_color_select_chain_hidden')

        let hidden_input_chain = document.createElement("input");
        hidden_input_chain.setAttribute("type", "hidden");
        hidden_input_chain.setAttribute(
            "name",
            'properties[' + chain_color_select_chain.getAttribute("data-name") + ']'
        );
        hidden_input_chain.setAttribute("value", "");
        hidden_input_chain.setAttribute("id", "chain_color_select_chain_hidden");
        hidden_input_chain.setAttribute("data-popout-input", "");
        document.querySelector("form.product-form").appendChild(hidden_input_chain);

        let chain_color_options = document.querySelectorAll('#chain-color-select-chain [data-popout-option]')
        for (let i = 0; i < chain_color_options.length; i++) {
            chain_color_options[i].addEventListener("click", function() {
                this.closest('popout-select').classList.remove('input-error')
                document
                    .getElementById("chain_color_select_chain_hidden")
                    .setAttribute("value", this.getAttribute('data-value'));
            });
        }
    }

    // handle letter gold select
    const chain_color_select_letter =
        document.getElementById("chain-color-select-letter");
    if (null !== chain_color_select_letter) {
        required_fields.push('chain_color_select_letter_hidden')

        let hidden_input_letter = document.createElement("input");
        hidden_input_letter.setAttribute("type", "hidden");
        hidden_input_letter.setAttribute(
            "name",
            'properties[' + chain_color_select_letter.getAttribute("data-name") + ']'
        );
        hidden_input_letter.setAttribute("value", "");
        hidden_input_letter.setAttribute("data-popout-input", "");
        hidden_input_letter.setAttribute("id", "chain_color_select_letter_hidden");
        document.querySelector("form.product-form").appendChild(hidden_input_letter);

        let letter_color_options = document.querySelectorAll('#chain-color-select-letter [data-popout-option]')
        for (let i = 0; i < letter_color_options.length; i++) {
            letter_color_options[i].addEventListener("click", function() {
                this.closest('popout-select').classList.remove('input-error')
                document
                    .getElementById("chain_color_select_letter_hidden")
                    .setAttribute("value", this.getAttribute('data-value'));
            });
        }
    }

    /* Save Single letter selects field for products */
    const single_letter_select =
        document.getElementById("single-letter-select");
    if (null !== single_letter_select) {
        required_fields.push('single_letter_select_hidden')

        let hidden_input_letter = document.createElement("input");
        hidden_input_letter.setAttribute("type", "hidden");
        hidden_input_letter.setAttribute(
            "name",
            'properties[' + single_letter_select.getAttribute("data-name") + ']'
        );
        hidden_input_letter.setAttribute("value", "");
        hidden_input_letter.setAttribute("id", "single_letter_select_hidden");
        hidden_input_letter.setAttribute("data-popout-input", "");
        document.querySelector("form.product-form").appendChild(hidden_input_letter);

        let single_letter_options = document.querySelectorAll('#single-letter-select [data-popout-option]')
        for (let i = 0; i < single_letter_options.length; i++) {
            single_letter_options[i].addEventListener("click", function() {
                this.closest('popout-select').classList.remove('input-error')
                document
                    .getElementById("single_letter_select_hidden")
                    .setAttribute("value", this.getAttribute('data-value'));
            });
        }
    }

    /* Save Double letter selects fields for products */
    // handle upper letter select
    const double_letter_select_upper =
        document.getElementById("double-letter-select-upper");
    if (null !== double_letter_select_upper) {
        required_fields.push('double_letter_select_upper_hidden')

        let hidden_input_upper = document.createElement("input");
        hidden_input_upper.setAttribute("type", "hidden");
        hidden_input_upper.setAttribute(
            "name",
            'properties[' + double_letter_select_upper.getAttribute("data-name") + ']'
        );
        hidden_input_upper.setAttribute("value", "");
        hidden_input_upper.setAttribute("id", "double_letter_select_upper_hidden");
        hidden_input_upper.setAttribute("data-popout-input", "");
        document.querySelector("form.product-form").appendChild(hidden_input_upper);

        let upper_letter_options = document.querySelectorAll('#double-letter-select-upper [data-popout-option]')
        for (let i = 0; i < upper_letter_options.length; i++) {
            upper_letter_options[i].addEventListener("click", function() {
                this.closest('popout-select').classList.remove('input-error')
                document
                    .getElementById("double_letter_select_upper_hidden")
                    .setAttribute("value", this.getAttribute('data-value'));
            });
        }
    }

    // handle letter gold select
    const double_letter_select_bottom =
        document.getElementById("double-letter-select-bottom");
    if (null !== double_letter_select_bottom) {
        required_fields.push('double_letter_select_bottom_hidden')

        let hidden_input_bottom = document.createElement("input");
        hidden_input_bottom.setAttribute("type", "hidden");
        hidden_input_bottom.setAttribute(
            "name",
            'properties[' + double_letter_select_bottom.getAttribute("data-name") + ']'
        );
        hidden_input_bottom.setAttribute("value", "");
        hidden_input_bottom.setAttribute("data-popout-input", "");
        hidden_input_bottom.setAttribute("id", "double_letter_select_bottom_hidden");
        document.querySelector("form.product-form").appendChild(hidden_input_bottom);

        let bottom_letter_options = document.querySelectorAll('#double-letter-select-bottom [data-popout-option]')
        for (let i = 0; i < bottom_letter_options.length; i++) {
            bottom_letter_options[i].addEventListener("click", function() {
                this.closest('popout-select').classList.remove('input-error')
                document
                    .getElementById("double_letter_select_bottom_hidden")
                    .setAttribute("value", this.getAttribute('data-value'));
            });
        }
    }

    // validate required custom fields
    function validateRequiredFields() {
        let valid = true

        required_fields.forEach(node =>{
            if(document.getElementById(node) === null ||
                (document.getElementById(node) !== null && document.getElementById(node).value === '' || document.getElementById(node).value === null)){
                valid = false
                document.querySelector('[data-hidden-input="' + node + '"]').classList.add('input-error')
            }
        })

        return valid
    }
    if(required_fields.length > 0){
        document.addEventListener('theme:cart:add', event => {
            if(!validateRequiredFields()){
                event.stopImmediatePropagation()
            }
        })
    }

    /* Dr Free Gift Translations */
    if (null !== document.getElementById('docapp-cart') || window.freeGiftCartUpsellProAppLoaded) {
        const translations = {
            'en': {
                'docapp-promo-popup__header__title': "Receive an exclusive sterling-silver piece on us",
                'docapp-promo-popup__header__body': "Discover the sterling-silver pieces we’ve curated for Diamond Cyber Week. Choose your favourite and enjoy it as a complimentary gift with your purchase.",
                'docapp-promo-popup__earned': "Selected gifts",
                'docapp-promo-popup__more': "Available gifts",
                'docapp-promo-popup__continue': "Continue shopping",
                'docapp-promo-offer-progress-percent': "Completed",
                'docapp-gift-re-choice-button-text': "Selecting gifts",
                'docapp-gift-choice-modal-title': "DIAMOND CYBER WEEK",
                'docapp-gift-choice-modal-sub-title': "You can choose one of these exclusive designs",
                'docapp-gift-choice-modal-decline-button': "No, thank you",
                'docapp-gift-choice-modal-done-button': "Continue shopping",
                'docapp-add-to-cart': "Add to cart",
                'docapp-gift-choice-modal-gift-price': "Gift",
                'docapp-variant-options-trigger': "Change gift",
                'docapp-promo-offer-info-text-main': "Complimentary gifts with purchases from "
            },
            'pt-PT': {
                'docapp-promo-popup__header__title': "Oferecemos-te uma joia exclusiva de prata",
                'docapp-promo-popup__header__body': "Descobre a seleção de joias em prata de lei que preparámos para celebrar o Diamond Cyber Week. Escolhe a tua favorita e recebe-a como oferta na tua compra",
                'docapp-promo-popup__earned': "Presentes selecionados",
                'docapp-promo-popup__more': "Presentes disponíveis",
                'docapp-promo-popup__continue': "Continuar a comprar",
                'docapp-promo-offer-progress-percent': "Concluído",
                'docapp-gift-re-choice-button-text': "Seleção de presentes",
                'docapp-gift-choice-modal-title': "DIAMOND CYBER WEEK",
                'docapp-gift-choice-modal-sub-title': "You can choose one of these exclusive designs. ",
                'docapp-gift-choice-modal-decline-button': "Não, obrigado",
                'docapp-gift-choice-modal-done-button': "Continue a comprar",
                'docapp-add-to-cart': "Adicionar ao carrinho",
                'docapp-gift-choice-modal-gift-price': "Prenda",
                'docapp-variant-options-trigger': "Troque o presente",
                'docapp-promo-offer-info-text-main': "Presentes para compras a partir de"
            }
        }
        const product_translations = {
            'en': {
                '8997512577268': "Essentia Heart Ring in Sterling Silver",
                '8997512642804': "Wave Ring in Sterling Silver",
                '8997512741108': "Bubble Glacé Hoop Earrings in Sterling Silver",
                '8997512806644': "Bubble Glacé Earrings in Sterling Silver",
                '8997512904948': "Moonrise Dreams Open Ring in Sterling Silver",
                '8997512937716': "Wave Open Hoop Earrings in Sterling Silver",
                '8997512970484': "Moonrise Dreams Ring in Sterling Silver",
                '8997513232628': "Moonrise Dreams Open Hoop Earrings in Sterling Silver",
                '8997513298164': "Wave Hoop Earrings in Sterling Silver",
                '8997513330932': "Moonrise Dreams Stud Earrings in Sterling Silver",
                '8997513822452': "Twist of Grace Ring in Sterling Silver",
                '8997513855220': "Essentia Large Open Hoop Earrings in Sterling Silver",
                '8997513887988': "Twist of Grace Hoop Earrings in Sterling Silver",
                '8997513953524': "Essentia Drop Earrings in Sterling Silver",
                '8997513986292': "Twist of Grace Knot Ring in Sterling Silver",
                '8997514051828': "Twist of Grace Small Open Hoop Earrings in Sterling Silver",
                '8997514117364': "Bubble Glacé Bracelet in Sterling Silver",
                '8997514150132': "Essentia Chain in Sterling Silver",
                '8997514248436': "Moonrise Dreams Drop Earrings in Sterling Silver",
                '8997514281204': "Moonrise Dreams Bracelet in Sterling Silver",
                '9221043912948': "Bold Move Ring in Sterling Silver",
                '9221044109556': "Vault Earrings in Sterling Silver",
                '9221044404468': "Mistral Necklace in Sterling Silver",
                '9221044338932': "Mistral Bracelet in Sterling Silver",
                '9220780884212': "Gravité Earrings in Sterling Silver",
                '9220780982516': "The New Link Bracelet in Sterling Silver",
                '9221042864372': "Rivulet Ring in Sterling Silver",
                '9221042569460': "Bold Move Earrings in Sterling Silver",
                '9221042503924': "Ellipse Earrings in Sterling Silver",
                '9221043093748': "Nimbus Ring in Sterling Silver",
                '9221043257588': "Tressé Earrings in Sterling Silver",
                '9221043683572': "Plissé Earrings in Sterling Silver",
                '9221043486964': "Trilogy Earrings in Sterling Silver",
                '9221042045172': "Trilogy Hoop Earrings in Sterling Silver",
                '9221041979636': "Nexus Earrings in Sterling Silver",
                '9221041946868': "Duet Necklace in Sterling Silver",
                '9221042012404': "Brume Earrings in Sterling Silver",
                '9221042405620': "Rivage Bracelet in Sterling Silver",
                '9221042274548': "Mirrorball Earrings in Sterling Silver",
                '9221042340084': "The New Link Earrings in Sterling Silver",
                '9221042372852': "Twin Lines Earrings in Sterling Silver",
                '9221042667764': "Trinelle Necklace in Sterling Silver"  
            },
            'pt-PT': {
                '8997512577268': "Anel Coração Essentia em prata de lei",
                '8997512642804': "Anel Onda em Prata de Lei",
                '8997512741108': "Brincos de argola Bubble Glacé em prata de lei",
                '8997512806644': "Brincos Bubble Glacé em prata de lei",
                '8997512904948': "Anel aberto Moonrise Dreams em prata de lei",
                '8997512937716': "Brincos de argola aberta Wave em prata de lei",
                '8997512970484': "Anel Moonrise Dreams em prata de lei",
                '8997513232628': "Brincos de argola aberta Moonrise Dreams em prata de lei",
                '8997513298164': "Brincos de argola em forma de onda em prata de lei",
                '8997513330932': "Brincos Moonrise Dreams em prata de lei",
                '8997513822452': "Anel Twist of Grace em prata de lei",
                '8997513855220': "Brincos de argola grande aberta Essentia em prata de lei",
                '8997513887988': "Brincos de argola Twist of Grace em prata de lei",
                '8997513953524': "Brincos de gota Essentia em prata de lei",
                '8997513986292': "Anel Twist of Grace Knot em prata de lei",
                '8997514051828': "Brincos de argola pequena aberta Twist of Grace em prata de lei",
                '8997514117364': "Pulseira Bubble Glacé em prata de lei",
                '8997514150132': "Corrente Essentia em prata de lei",
                '8997514248436': "Brincos Moonrise Dreams em prata de lei",
                '8997514281204': "Pulseira Moonrise Dreams em Prata de Lei",
                '9221043912948': "Anel Bold Move em Prata de Lei",
                '9221044109556': "Brincos Vault em Prata de Lei",
                '9221044404468': "Colar Mistral em Prata de Lei",
                '9221044338932': "Pulseira Mistral em Prata de Lei",
                '9220780884212': "Brincos Gravité em Prata de Lei",
                '9220780982516': "Pulseira The New Link em Prata de Lei",
                '9221042864372': "Anel Rivulet em Prata de Lei",
                '9221042569460': "Brincos Bold Move em Prata de Lei",
                '9221042503924': "Brincos Ellipse em Prata de Lei",
                '9221043093748': "Anel Nimbus em Prata de Lei",
                '9221043257588': "Brincos Tressé em Prata de Lei",
                '9221043683572': "Brincos Plissé em Prata de Lei",
                '9221043486964': "Brincos Trilogy em Prata de Lei",
                '9221042045172': "Argolas Trilogy em Prata de Lei",
                '9221041979636': "Brincos Nexus em Prata de Lei",
                '9221041946868': "Colar Duet em Prata de Lei",
                '9221042012404': "Brincos Brume em Prata de Lei",
                '9221042405620': "Pulseira Rivage em Prata de Lei",
                '9221042274548': "Brincos Mirrorball em Prata de Lei",
                '9221042340084': "Brincos The New Link em Prata de Lei",
                '9221042372852': "Brincos Twin Lines em Prata de Lei",
                '9221042667764': "Colar Trinelle em Prata de Lei"
            }
        }

        var tries = 0;
        function popupLoaded() {
            tries++
            if(document.getElementsByClassName('docapp-promo-popup').length > 0){
                translate();
                if(document.getElementsByClassName('docapp-gift-choices').length > 0) {
                    translateProducts();
                    enhanceModalImages();
                }

                // add listener to dynamic elements
                document.addEventListener("click", function(e){
                    const popup_open_buttons = e.target.closest(".docapp-free-gift-float-icon");
                    const modal_open_buttons = e.target.closest(".docapp-gift-re-choice-button");
                    const popup_close_button = e.target.closest(".docapp-promo-close");
                    const modal_close_button = e.target.closest(".docapp-overlay-close");

                    if(popup_open_buttons){
                        translate()
                    }
                    if(modal_open_buttons){
                        translate()
                        translateProducts()
                        // Enhance images when modal opens
                        setTimeout(enhanceModalImages, 100);
                    }
                    if(popup_close_button || modal_close_button){
                        hideTexts()
                    }
                });

                // add listener to the popup button to translate dynamic content
                let popup_open_buttons = document.getElementsByClassName('docapp-free-gift-float-icon')
                for (let i = 0; i < popup_open_buttons.length; i++) {
                    popup_open_buttons[i].addEventListener('click', translate)
                    popup_open_buttons[i].addEventListener('click', () => {
                        const icon = document.querySelector('.docapp-free-gift-float-icon.docapp-promo-widget-variables.docapp-free-gift-circle');
                        if (icon) {
                            icon.classList.add('disabled-animation');
                        }
                    });
                }

                // listener to translate the choice modal
                let modal_open_buttons = document.getElementsByClassName('docapp-gift-re-choice-button')
                for (let i = 0; i < modal_open_buttons.length; i++) {
                    console.log("click asociado");
                    modal_open_buttons[i].addEventListener('click', translate);
                    modal_open_buttons[i].addEventListener('click', translateProducts);
                    modal_open_buttons[i].addEventListener('click', () => {
                        setTimeout(enhanceModalImages, 200);
                    });
                }

                tries = 0;
                return true;
            }
            if(tries > 100) return false;
            setTimeout(popupLoaded, 500)
        }

        function modalLoaded() {
            tries++
            if(document.getElementsByClassName('docapp-gift-choices').length > 0){
                translate();
                translateProducts();
                enhanceModalImages();

                tries = 0;
                return true;
            }
            if(tries > 50) return false;
            setTimeout(modalLoaded, 500)
        }

        function translate()
        {
            console.log("lanzado translate?");
            let translated = false
            let current_lang_code = document.querySelector('[name="locale_code"]').value
            let current_transaltions = translations[current_lang_code]

            Object.keys(current_transaltions).forEach(function (element_class) {
                let elements = document.getElementsByClassName(element_class)
                for (let i = 0; i < elements.length; i++) {
                    if(element_class === 'docapp-promo-offer-progress-percent' && elements[i].textContent.indexOf('%') > 0) {
                        let special_translations = {
                            'en': "Complete",
                            'pt-PT': "Completo"
                        }
                        elements[i].textContent = elements[i].textContent.substr(0, elements[i].textContent.indexOf('%') + 2) + special_translations[current_lang_code]
                    }else if(element_class === 'docapp-promo-offer-info-text-main'){
                        elements[i].textContent = elements[i].textContent.replace('Regalos por compras desde', current_transaltions[element_class])
                    }else{
                        elements[i].textContent = current_transaltions[element_class]
                    }

                    translated = true
                }
            });

            if(null === document.getElementById('docapp-translation-css')) {
                let el = document.createElement('style')
                el.id = 'docapp-translation-css'
                el.textContent = '.' + Object.keys(translations['en']).join(', .') + '{opacity: 1 !important}';
                document.head.appendChild(el)
            }
        }

        // translate product titles
        function translateProducts()
        {
            let translated = false
            let current_lang_code = document.querySelector('[name="locale_code"]').value

            document.querySelectorAll('[name="docapp_product_id"]').forEach(el => {
                if(undefined !== product_translations[current_lang_code][el.value])
                {
                    el.parentElement.parentElement.childNodes[1].textContent = product_translations[current_lang_code][el.value];
                    translated = true
                }
            })

            if(translated && null === document.getElementById('docapp-product-translation-css')) {
                let el = document.createElement('style')
                el.id = 'docapp-product-translation-css'
                el.textContent = '.docapp-gift-choice-modal-item-title{opacity: 1 !important}';
                document.head.appendChild(el)
            }
        }

        function hideTexts() {
            // hide all translatable texts before tranlsate
            const el = document.createElement('style')
            el.textContent = '.' + Object.keys(translations['en']).join(', .') + '{opacity: 0;transition: .2s opacity ease-out}';
            document.head.appendChild(el)
            const el2 = document.createElement('style')
            el2.textContent = '.docapp-gift-choice-modal-item-title{opacity: 0;transition: .2s opacity ease-out}';
            document.head.appendChild(el2)

            let translation_css = document.getElementById('docapp-translation-css')
            if(null !== translation_css) translation_css.remove()
            let product_translation_css = document.getElementById('docapp-product-translation-css')
            if(null !== product_translation_css) product_translation_css.remove()
        }

        // Enhance modal images: increase size and resolution
        function enhanceModalImages() {
            // Modify image URLs to get higher resolution
            const modalImages = document.querySelectorAll('.docapp-gift-choice-modal-item-image');
            
            modalImages.forEach(img => {
                if (img.src) {
                    // Modify URL to get higher resolution (400px for better quality)
                    let newSrc = img.src;
                    let urlChanged = false;
                    
                    // Pattern 1: Replace _100x, _150x, _200x, etc. with _400x for better resolution
                    if (newSrc.match(/_(\d+)x\.(webp|jpg|png|jpeg)/gi)) {
                        const oldSrc = newSrc;
                        newSrc = newSrc.replace(/_(\d+)x\.(webp|jpg|png|jpeg)/gi, '_400x.$2');
                        if (oldSrc !== newSrc) urlChanged = true;
                    }
                    
                    // Pattern 2: If URL has ?width= parameter, increase it to 400
                    if (newSrc.includes('?width=')) {
                        const oldSrc = newSrc;
                        newSrc = newSrc.replace(/\?width=(\d+)/, '?width=400');
                        if (oldSrc !== newSrc) urlChanged = true;
                    } else if (newSrc.includes('&width=')) {
                        const oldSrc = newSrc;
                        newSrc = newSrc.replace(/&width=(\d+)/, '&width=400');
                        if (oldSrc !== newSrc) urlChanged = true;
                    } else if (!newSrc.includes('_400x') && !newSrc.includes('width=') && newSrc.includes('cdn.shopify.com')) {
                        // Add width parameter if not present (only for Shopify CDN URLs)
                        const separator = newSrc.includes('?') ? '&' : '?';
                        newSrc = newSrc + separator + 'width=400';
                        urlChanged = true;
                    }
                    
                    // Update URL if it changed
                    if (urlChanged && newSrc !== img.src) {
                        img.src = newSrc;
                    }
                }
            });

            // Inject CSS to enlarge images and containers (only once)
            if (null === document.getElementById('docapp-image-enhancement-css')) {
                const styleEl = document.createElement('style');
                styleEl.id = 'docapp-image-enhancement-css';
                styleEl.textContent = `
                    .docapp-gift-choice-modal-item-image-container {
                        width: 200px !important;
                        height: 250px !important;
                        min-width: 200px !important;
                        min-height: 250px !important;
                        max-width: 200px !important;
                        max-height: 250px !important;
                    }
                    .docapp-gift-choice-modal-item-image {
                        width: 190px !important;
                        height: 250px !important;
                        min-width: 190px !important;
                        min-height: 250px !important;
                        max-width: 190px !important;
                        max-height: 250px !important;
                        object-fit: cover !important;
                    }
                    .docapp-gift-choice-modal-item-wrapper {
                        min-width: 200px !important;
                        
                    }
                `;
                document.head.appendChild(styleEl);
            }
        }

        // run translate if the language selected
        let current_lang_code = document.querySelector('[name="locale_code"]').value
        if (null !== current_lang_code && current_lang_code !== 'es')
        {
            hideTexts()

            // check first popup is rendered
            popupLoaded()

            var windowReady = setInterval(() => {
                if (typeof window.addEventListener === 'function') {
                    clearInterval(windowReady);
                    console.log('docapp mutate')
                    window.addEventListener('SCE:mutate', (event) => {
                        // check second model is rendered after cart change
                        modalLoaded()
                    })
                }
            }, 300);

            // register cart change event
            (function () {
                if (!window || !window.Shopify) return;

                const CartEvents = {
                    mutate: "SCE:mutate"
                };

                const ShopifyCartURLs = [
                    "/cart/add",
                    "/cart/update",
                    "/cart/change",
                    "/cart/clear",
                    "/cart/add.js",
                    "/cart/update.js",
                    "/cart/change.js",
                    "/cart/clear.js",
                ];

                function isShopifyCartURL(url) {
                    if (!url) return false;
                    const path = url.split("/").pop();
                    return ShopifyCartURLs.includes(`/cart/${path}`);
                }

                function dispatchEvent(url, detail) {
                    if (typeof detail === "string") {
                        try {
                            detail = JSON.parse(detail);
                        } catch {}
                    }

                    window.dispatchEvent(new CustomEvent(CartEvents.mutate, { detail }));
                }

                function XHROverride() {
                    if (!window.XMLHttpRequest) return;

                    const originalOpen = window.XMLHttpRequest.prototype.open;
                    window.XMLHttpRequest.prototype.open = function () {
                        const url = arguments[1];
                        this.addEventListener("load", function () {
                            if (isShopifyCartURL(url)) {
                                dispatchEvent(url, this.response);
                            }
                        });
                        return originalOpen.apply(this, arguments);
                    };
                }

                function fetchOverride() {
                    if (!window.fetch || typeof window.fetch !== "function") return;
                    const originalFetch = window.fetch;
                    window.fetch = function () {
                        const response = originalFetch.apply(this, arguments);

                        if (isShopifyCartURL(arguments[0])) {
                            response.then((res) => {
                                res
                                    .clone()
                                    .json()
                                    .then((data) => dispatchEvent(res.url, data));
                            });
                        }

                        return response;
                    };
                }

                fetchOverride();
                XHROverride();
            })();
        }

        // Always enhance modal images regardless of language
        // This ensures images are larger and higher resolution for all users
        function initImageEnhancement() {
            // Check if modal is already loaded
            if(document.getElementsByClassName('docapp-gift-choices').length > 0) {
                enhanceModalImages();
            }

            // Polling to detect when modal loads
            var imageTries = 0;
            function checkModalForImages() {
                imageTries++;
                if(document.getElementsByClassName('docapp-gift-choices').length > 0) {
                    enhanceModalImages();
                    imageTries = 0;
                    return true;
                }
                if(imageTries > 100) return false;
                setTimeout(checkModalForImages, 500);
            }
            checkModalForImages();

            // Listen for modal opening events
            document.addEventListener("click", function(e){
                const modal_open_buttons = e.target.closest(".docapp-gift-re-choice-button");
                if(modal_open_buttons) {
                    setTimeout(enhanceModalImages, 300);
                }
            });

            // Listen for cart changes that might reload the modal
            if (typeof window.addEventListener === 'function') {
                window.addEventListener('SCE:mutate', (event) => {
                    setTimeout(enhanceModalImages, 500);
                });
            }
        }

        // Initialize image enhancement
        initImageEnhancement();
    }

    /* Lock gift product quantity to 1 in cart drawer and cart page */
    const giftProductId = window.theme?.settings?.giftProductId;

    if (giftProductId) {
        function getGiftCartItems() {
            return document.querySelectorAll(
                `.cart__item[data-product-id="${giftProductId}"]`
            );
        }

        function resetGiftProductQuantity(item) {
            const lineIndex = parseInt(item.getAttribute("data-item-index"), 10);
            const quantity = parseInt(item.getAttribute("data-item-quantity"), 10);

            if (!lineIndex || !quantity || quantity <= 1) return;

            fetch(window.theme.routes.cart_change_url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
                body: JSON.stringify({ line: lineIndex, quantity: 1 }),
            })
                .then((response) => response.json())
                .then((data) => {
                    if (data.errors) return;

                    const cartItems = document.querySelector("cart-items");
                    if (cartItems && typeof cartItems.getCart === "function") {
                        cartItems.getCart();
                    }
                });
        }

        function enforceGiftProductQuantity() {
            getGiftCartItems().forEach(resetGiftProductQuantity);
        }

        document.addEventListener(
            "theme:cart:update",
            (event) => {
                const item = event.target?.closest?.("[data-product-id]");
                if (!item || parseInt(item.dataset.productId, 10) !== giftProductId) {
                    return;
                }

                const quantity = parseInt(event.detail?.quantity, 10);
                if (quantity > 1) {
                    event.detail.quantity = 1;
                }
            },
            true
        );

        document.addEventListener("theme:cart:load", enforceGiftProductQuantity);
        document.addEventListener("theme:cart:change", enforceGiftProductQuantity);
    }

    // ^^ Keep your scripts inside this IIFE function call to
    // avoid leaking your variables into the global scope.
})();
